/**
 * Session-scoped selection cache for Project pages, keyed by projectId.
 *
 * Lives at module scope so it survives ProjectPage unmount/remount —
 * e.g. when the user switches to a Quick Notes tab and back. Otherwise
 * a fresh `useRef({})` would reset the cache on every remount and every
 * project selection would be lost on tab-type changes.
 */
export type ProjectSelectionEntry = {
  focusedId: string | null
  selectedIds: string[]
}

export const projectSelectionCache: Record<string, ProjectSelectionEntry> = {}
